import React from 'react';
import { withTranslation } from 'react-i18next';
import BannerImageResponsiveEn from '@img/landing/banner/banner-mobile.jpg';
import BannerImageEn from '@img/landing/banner/banner_new.jpg';
import {
  AboutBackground as AboutBackgroundEn,
  AboutBackgroundResponsive as AboutBackgroundResponsiveEn,
  PatientBenefit as PatientBenefitEn,
  PatientBenefitResponsive as PatientBenefitResponsiveEn,
  ClinicBenefit as ClinicBenefitEn,
  ClinicBenefitResponsive as ClinicBenefitResponsiveEn,
} from '@img/about';
import {
  TermsBanner as TermsBannerEn,
  TermsBannerResponsive as TermsBannerResponsiveEn,
} from '@img/terms';
import { ChevronUpFilled as ChevronUpFilledEn } from '@img/products';
import {
  ChevronLeftIcon as ChevronLeftIconEn,
  ChevronRightIcon as ChevronRightIconEn,
} from '@img/dashboard';
import { SearchIcon as SearchIconEn } from '@img/dashboard';
import LogoPlaceholderEn from '@img/logo/logo_placeholder.png';
import {
  MinusIcon as MinusIconEn,
  PlusIcon as PlusIconEn,
} from '@img/recommendation';
import {
  DollarSignIcon as DollarSignIconEn,
  GiftCardIcon as GiftCardIconEn,
} from '@img/dashboard';
import {
  LifelineIcon as LifelineIconEn,
  FlagIcon as FlagIconEn,
  PurchasesIcon as PurchasesIconEn,
  CalendarIcon as CalendarIconEn,
} from '@img/dashboard';
import CloseIconEn from '@img/docs/close.svg';
import { default as FirstTileEn } from '@img/landing/products/tile_01@2x.jpg';
import { default as SecondTileEn } from '@img/landing/products/tile_02@2x.jpg';
import { default as ThirdTileEn } from '@img/landing/products/tile_03@2x.jpg';
import PatientSatisfactionImageEn from '@img/landing/patient_satisfaction/patient_satisfaction@2x.jpg';
import { Checkmark as CheckmarkEn } from '@img/common';
import ChecklistIconEn from '@img/common/checklist.svg';
import { PlayIcon as PlayIconEn } from '@img/common';
import ExclamationPointEn from '@img/common/exclamation-point.svg';
import LogoImageEn from '@img/logo/logo.svg';
import LogoImageJp from '@img/logo/HVS-My-Hills-Shop.svg';
import LogoMobileImgEn from '@img/logo/logo.svg';
import {
  AwardIcon as AwardIconEn,
  SendIcon as SendIconEn,
  ShoppingBagIcon as ShoppingBagIconEn,
} from '@img/landing/how_it_works';
import MenuIconEn from '@img/common/menu.svg';
import CheckIconEn from '@img/landing/benefit/check.svg';
import LivingRoomCatImgEn from '@img/landing/benefit/living-room-cat.png';
import LivingRoomCatMobileImgEn from '@img/landing/benefit/living-room-cat-mobile.png';
import {
  DashboardIcon as DashboardIconEn,
  ShoppingCartIcon as ShoppingCartIconEn,
  DownChevronIcon as DownChevronIconEn,
  AddToCartIcon as AddToCartIconEn,
  AddToCartGrayIcon as AddToCartGrayIconEn,
  TrashIcon as TrashIconEn,
  OutBoundLinkIconBlue as OutBoundLinkIconBlueEn,
  DownloadIcon as DownloadIconEn,
} from '@img/dashboard';
import ComplainceIconEn from '@img/landing/benefit/complaince.svg';
import ComplianceIconEn from '@img/landing/how_it_works/icon-compliance.svg';
import RevenueStreamIconEn from '@img/landing/how_it_works/icon-revenue-stream.svg';
import SimplifyOperationsEn from '@img/landing/how_it_works/icon-simplify-operations.svg';
import OperationsIconEn from '@img/landing/benefit/operations.svg';
import RevenueIconEn from '@img/landing/benefit/revenue.svg';
import EllipseImgEn from '@img/landing/testimonial/ellipse.svg';
import YoutubeIconEn from '@img/landing/footer/youtube.svg';
import FacebookIconEn from '@img/landing/footer/facebook.svg';
import TwitterIconEn from '@img/landing/footer/twitter.svg';
import NaverIconEn from '@img/landing/footer/naver.svg';
import InstagramIconEn from '@img/landing/footer/instagram.svg';
import { ArrowUp as ArrowUpEn, ArrowDown as ArrowDownEn } from '@img/support';
import HamburgerIconEn from '@img/landing/menu/hamburger.svg';
import LensIconEn from '@img/landing/menu/lens.svg';
import PersonIconEn from '@img/landing/menu/person.svg';
import ExternalLinkIconEn from '@img/landing/menu/external-link.svg';
import CloseBlueIconEn from '@img/landing/menu/close-blue.svg';
import QRCodeFlyerHeaderEn from '@img/qr-code-flyer/header.png';
import QRCodeFlyerProductsEn from '@img/qr-code-flyer/products.png';
import QRCodeFlyerFooterEn from '@img/qr-code-flyer/footer.png';
import QRCodeFlyerJp1 from '@img/qr-code-flyer/jp-1.png';
import QRCodeFlyerJp2 from '@img/qr-code-flyer/jp-2.png';
import AccountApprovedDogImageEn from '@img/common/account-approved-dog.png';
import PawLoadingEn from '@img/dashboard/paw-loading.gif';

function getUrl(cfg, lang) {
  switch (lang) {
    default:
      return cfg['en'];
  }
}

export const AccountApprovedDogImage = withTranslation()(
  function AccountApprovedDogImage({ i18n, t, tReady, ...props }) {
    return (
      <img
        src={getUrl(
          {
            en: AccountApprovedDogImageEn,
          },
          i18n.language
        )}
        alt={t('afterWelcome_modalSubheader')}
        {...props}
      />
    );
  }
);

export const BannerImageResponsive = withTranslation()(
  function BannerImageResponsive({ i18n, t, tReady, ...props }) {
    return (
      <img
        src={getUrl(
          {
            en: BannerImageResponsiveEn,
          },
          i18n.language
        )}
        {...props}
      />
    );
  }
);

export const BannerImage = withTranslation()(function BannerImage({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={props.alt || ''}
      src={getUrl(
        {
          en: BannerImageEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const AboutBackground = withTranslation()(function AboutBackground({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_About')}
      src={getUrl(
        {
          en: AboutBackgroundEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const AboutBackgroundResponsive = withTranslation()(
  function AboutBackgroundResponsive({ i18n, t, tReady, ...props }) {
    return (
      <img
        alt={t('accessibility_About')}
        src={getUrl(
          {
            en: AboutBackgroundResponsiveEn,
          },
          i18n.language
        )}
        {...props}
      />
    );
  }
);

export const TermsBanner = withTranslation()(function TermsBanner({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: TermsBannerEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const TermsBannerResponsive = withTranslation()(
  function TermsBannerResponsive({ i18n, t, tReady, ...props }) {
    return (
      <img
        src={getUrl(
          {
            en: TermsBannerResponsiveEn,
          },
          i18n.language
        )}
        {...props}
      />
    );
  }
);

export const PatientBenefit = withTranslation()(function PatientBenefit({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_PatientBenefit')}
      src={getUrl(
        {
          en: PatientBenefitEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const PatientBenefitResponsive = withTranslation()(
  function PatientBenefitResponsive({ i18n, t, tReady, ...props }) {
    return (
      <img
        alt={t('accessibility_PatientBenefit')}
        src={getUrl(
          {
            en: PatientBenefitResponsiveEn,
          },
          i18n.language
        )}
        {...props}
      />
    );
  }
);

export const ClinicBenefitImg = withTranslation()(function ClinicBenefit({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: ClinicBenefitEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const ClinicBenefitResponsiveImg = withTranslation()(
  function ClinicBenefitResponsive({ i18n, t, tReady, ...props }) {
    return (
      <img
        src={getUrl(
          {
            en: ClinicBenefitResponsiveEn,
          },
          i18n.language
        )}
        {...props}
      />
    );
  }
);

export const ChevronUpFilled = withTranslation()(function ChevronUpFilled({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: ChevronUpFilledEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const MinusIcon = withTranslation()(function MinusIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: MinusIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const PlusIcon = withTranslation()(function PlusIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: PlusIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const ChevronLeftIcon = withTranslation()(function ChevronLeftIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('paging_Previous')}
      src={getUrl(
        {
          en: ChevronLeftIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const ChevronRightIcon = withTranslation()(function ChevronRightIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('paging_Next')}
      src={getUrl(
        {
          en: ChevronRightIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const CloseIcon = withTranslation()(function CloseIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: CloseIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const CloseBlueIcon = withTranslation()(function CloseBlueIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: CloseBlueIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const Checkmark = withTranslation()(function Checkmark({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: CheckmarkEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const ChecklistIcon = withTranslation()(function ChecklistIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: ChecklistIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const PlayIcon = withTranslation()(function PlayIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: PlayIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const LogoImage = withTranslation()(function LogoImage({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_Logo')}
      src={getUrl(
        {
          en: LogoImageEn,
        },
        i18n.language
      )}
      {...props}
      className="header-logo"
    />
  );
});

export const LogoImageJpStore = withTranslation()(function LogoImage({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_Logo')}
      src={getUrl(
        {
          en: LogoImageJp,
        },
        i18n.language
      )}
      {...props}
      className="header-logo"
    />
  );
});

export const LogoMobileImg = withTranslation()(function LogoMobileImg({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_Logo')}
      className="mobile-logo"
      src={getUrl(
        {
          en: LogoMobileImgEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const MenuIcon = withTranslation()(function MenuIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_Menu')}
      src={getUrl(
        {
          en: MenuIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const CheckIcon = withTranslation()(function CheckIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={props.alt || ''}
      src={getUrl(
        {
          en: CheckIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const ArrowUp = withTranslation()(function ArrowUp({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: ArrowUpEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const LivingRoomCatImg = withTranslation()(function LivingRoomCatImg({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: LivingRoomCatImgEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const ArrowDown = withTranslation()(function ArrowDown({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: ArrowDownEn,
        },
        i18n.language
      )}
      {...props}
      alt={t('support_FaqArrowDown')}
    />
  );
});

export const LivingRoomCatMobileImg = withTranslation()(
  function LivingRoomCatMobileImg({ i18n, t, tReady, ...props }) {
    return (
      <img
        src={getUrl(
          {
            en: LivingRoomCatMobileImgEn,
          },
          i18n.language
        )}
        {...props}
      />
    );
  }
);

export const ComplainceIcon = withTranslation()(function ComplainceIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_Compliance')}
      src={getUrl(
        {
          en: ComplainceIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const OperationsIcon = withTranslation()(function OperationsIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_Operations')}
      src={getUrl(
        {
          en: OperationsIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const RevenueIcon = withTranslation()(function RevenueIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_Revenue')}
      src={getUrl(
        {
          en: RevenueIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const EllipseImg = withTranslation()(function EllipseImg({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('')}
      src={getUrl(
        {
          en: EllipseImgEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const YoutubeIcon = withTranslation()(function YoutubeIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_YoutubeAccount')}
      src={getUrl(
        {
          en: YoutubeIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const FacebookIcon = withTranslation()(function FacebookIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_FacebookAccount')}
      src={getUrl(
        {
          en: FacebookIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const TwitterIcon = withTranslation()(function TwitterIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_TwitterAccount')}
      src={getUrl(
        {
          en: TwitterIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const NaverIcon = withTranslation()(function NaverIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_NaverAccount')}
      src={getUrl(
        {
          en: NaverIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const InstagramIcon = withTranslation()(function InstagramIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_InstagramAccount')}
      src={getUrl(
        {
          en: InstagramIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const AddToCartIcon = withTranslation()(function AddToCartIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_AddToRecommendations')}
      src={getUrl(
        {
          en: AddToCartIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const TrashIcon = withTranslation()(function TrashIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: TrashIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const AddToCartGrayIcon = withTranslation()(function AddToCartGrayIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_AddedToRecommendations')}
      src={getUrl(
        {
          en: AddToCartGrayIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const CalendarIcon = withTranslation()(function CalendarIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: CalendarIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const HamburgerIcon = withTranslation()(function HamburgerIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: HamburgerIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const LensIcon = withTranslation()(function LensIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: LensIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const PersonIcon = withTranslation()(function PersonIcon({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_MyAccount')}
      src={getUrl(
        {
          en: PersonIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const ExternalLinkIcon = withTranslation()(function ExternalLink({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      alt={t('accessibility_ExternalLink')}
      src={getUrl(
        {
          en: ExternalLinkIconEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const QRCodeFlyerHeader = withTranslation()(function QRCodeFlyerHeader({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: QRCodeFlyerHeaderEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const QRCodeFlyerProducts = withTranslation()(
  function QRCodeFlyerProducts({ i18n, t, tReady, ...props }) {
    return (
      <img
        src={getUrl(
          {
            en: QRCodeFlyerProductsEn,
          },
          i18n.language
        )}
        {...props}
      />
    );
  }
);

export const QRCodeFlyerFooter = withTranslation()(function QRCodeFlyerFooter({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: QRCodeFlyerFooterEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const QRCodeFlyerJP1 = withTranslation()(function QRCodeFlyerFooter({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: QRCodeFlyerJp1,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export const QRCodeFlyerJP2 = withTranslation()(function QRCodeFlyerFooter({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: QRCodeFlyerJp2,
        },
        i18n.language
      )}
      {...props}
    />
  );
});

export function searchIconUrl(i18n) {
  return getUrl(
    {
      en: SearchIconEn,
    },
    i18n.language
  );
}

export function OutBoundLinkIconBlue(i18n) {
  return getUrl(
    {
      en: OutBoundLinkIconBlueEn,
    },
    i18n.language
  );
}

export function DownloadIcon(i18n) {
  return getUrl(
    {
      en: DownloadIconEn,
    },
    i18n.language
  );
}

export function logoPlaceholderUrl(i18n) {
  return getUrl(
    {
      en: LogoPlaceholderEn,
    },
    i18n.language
  );
}

export function dollarSignIconUrl(i18n) {
  return getUrl(
    {
      en: DollarSignIconEn,
    },
    i18n.language
  );
}

export function giftCardIconUrl(i18n) {
  return getUrl(
    {
      en: GiftCardIconEn,
    },
    i18n.language
  );
}

export function lifelineIconUrl(i18n) {
  return getUrl(
    {
      en: LifelineIconEn,
    },
    i18n.language
  );
}

export function flagIconUrl(i18n) {
  return getUrl(
    {
      en: FlagIconEn,
    },
    i18n.language
  );
}

export function purchasesIconUrl(i18n) {
  return getUrl(
    {
      en: PurchasesIconEn,
    },
    i18n.language
  );
}

export function patientSatisfactionImageUrl(i18n) {
  return getUrl(
    {
      en: PatientSatisfactionImageEn,
    },
    i18n.language
  );
}

export function awardIconUrl(i18n) {
  return getUrl(
    {
      en: AwardIconEn,
    },
    i18n.language
  );
}

export function sendIconUrl(i18n) {
  return getUrl(
    {
      en: SendIconEn,
    },
    i18n.language
  );
}

export function shoppingBagIconUrl(i18n) {
  return getUrl(
    {
      en: ShoppingBagIconEn,
    },
    i18n.language
  );
}

export function dashboardIconUrl(i18n) {
  return getUrl(
    {
      en: DashboardIconEn,
    },
    i18n.language
  );
}

export function shoppingCartIconUrl(i18n) {
  return getUrl(
    {
      en: ShoppingCartIconEn,
    },
    i18n.language
  );
}

export function downChevronIconUrl(i18n) {
  return getUrl(
    {
      en: DownChevronIconEn,
    },
    i18n.language
  );
}

export function complianceIconUrl(i18n) {
  return getUrl(
    {
      en: ComplianceIconEn,
    },
    i18n.language
  );
}

export function simplifyOperationsIconUrl(i18n) {
  return getUrl(
    {
      en: SimplifyOperationsEn,
    },
    i18n.language
  );
}

export function revenueStreamIconUrl(i18n) {
  return getUrl(
    {
      en: RevenueStreamIconEn,
    },
    i18n.language
  );
}

export function PawLoadingUrl(i18n) {
  return getUrl(
    {
      en: PawLoadingEn,
    },
    i18n.language
  );
}

export function tilesUrls(i18n) {
  return [
    getUrl(
      {
        en: FirstTileEn,
      },
      i18n.language
    ),
    getUrl(
      {
        en: SecondTileEn,
      },
      i18n.language
    ),
    getUrl(
      {
        en: ThirdTileEn,
      },
      i18n.language
    ),
  ];
}

export const ExclamationPoint = withTranslation()(function ExclamationPoint({
  i18n,
  t,
  tReady,
  ...props
}) {
  return (
    <img
      src={getUrl(
        {
          en: ExclamationPointEn,
        },
        i18n.language
      )}
      {...props}
    />
  );
});
